import api from './api';

export default {
  getBanksList() {
    let filters = {
      whereHas: [
        {
          relation: 'businessType',
          filters: { where: [['name', '=', 'bank']] }
        }
      ]
    };

    let params = {
      orderby: 'name',
      includes: 'users',
      filters
    };

    return new Promise((resolve, reject) => {
      api
        .get('business', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getBank(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`business/${id}`, {
          params: {
            includes: 'users'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  update(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`business/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
